import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';


export const TablaResumen = (props) => {
    const { datosTabla, titulo } = props;

    const plantillaErrorRegistroPatronal = (rowData, column) => {
        if (column.rowData.observacionRegistroPatronal != null)
            return <p>{column.rowData.registroPatronal + " " + column.rowData.observacionRegistroPatronal}</p>

        else
            return <p >{column.rowData.registroPatronal}</p>
    }

    const plantillaIconoValido = (rowData, column) => {
        if (column.rowData.observacionRegistroPatronal === null && column.rowData.observacionNumeroSeguroSocial === null && column.rowData.observacionDigitoVerificador === null && column.rowData.observacionPrimerApellido === null && column.rowData.observacionSegundoApellido === null && column.rowData.observacionNombre === null && column.rowData.observacionSalarioBase === null && column.rowData.observacionTipoTrabajador === null && column.rowData.observacionTipoSalario === null && column.rowData.observacionJornadaReducida === null && column.rowData.observacionFechaMovimiento === null && column.rowData.observacionUmf === null && column.rowData.observacionNumeroGuia === null && column.rowData.observacionClaveTrabajador === null && column.rowData.observacionCurp === null && column.rowData.observacionUltimiDigito === null && column.rowData.observacionTipoMovimiento === null && column.rowData.observacionCausaBaja === null)
            return (
                <div className="p-grid">
                    <div className="p-col-12 p-md-2">
                        <Button
                            type="button"
                            icon="pi-md-check-circle"
                            className="p-button-success"
                            name="estatus de linea"
                            tooltip="Estatus de linea"
                        ></Button>
                    </div>
                </div>
            );
        else
            return (
                <div className="p-grid">
                    <div className="p-col-12 p-md-2">
                        <Button
                            type="button"
                            icon="pi-md-check-circle pi pi-times"
                            className="p-button-danger"
                            name="estatus de linea"
                            tooltip="Estatus de linea"
                        ></Button>
                    </div>
                </div>
            );
    }

    const plantillaErrorNumeroSeguroSocial = (rowData, column) => {
        if (column.rowData.observacionNumeroSeguroSocial != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.numeroSeguroSocial + " " + column.rowData.observacionNumeroSeguroSocial}</p>

        else
            return <p >{column.rowData.numeroSeguroSocial}</p>
    }

    const plantillaErrorDigitoVerificador = (rowData, column) => {
        if (column.rowData.observacionDigitoVerificador != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.digitoVerificador + " " + column.rowData.observacionDigitoVerificador}</p>

        else
            return <p >{column.rowData.digitoVerificador}</p>
    }

    const plantillaErrorApellidoPaterno = (rowData, column) => {
        if (column.rowData.observacionPrimerApellido != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.primerApellido + " " + column.rowData.observacionPrimerApellido}</p>

        else
            return <p>{column.rowData.primerApellido}</p>
    }

    const plantillaErrorApellidoMaterno = (rowData, column) => {
        if (column.rowData.observacionSegundoApellido != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.segundoApellido + " " + column.rowData.observacionSegundoApellido}</p>

        else
            return <p >{column.rowData.segundoApellido}</p>
    }

    const plantillaErrorNombre = (rowData, column) => {

        if (column.rowData.observacionNombre != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.nombre + " " + column.rowData.observacionNombre}</p>

        else
            return <p>{column.rowData.nombre}</p>

    }

    const plantillaErrorSalarioBase = (rowData, column) => {
        if (column.rowData.observacionSalarioBase != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.salarioBase + " " + column.rowData.observacionSalarioBase}</p>

        else
            return <p>{column.rowData.salarioBase}</p>
    }

    const plantillaErrorTipoTrabajador = (rowData, column) => {
        if (column.rowData.observacionTipoTrabajador != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.tipoTrabajador + " " + column.rowData.observacionTipoTrabajador}</p>

        else
            return <p>{column.rowData.tipoTrabajador}</p>
    }

    const plantillaErrorTipoSalario = (rowData, column) => {
        if (column.rowData.observacionTipoSalario != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.tipoSalario + " " + column.rowData.observacionTipoSalario}</p>

        else
            return <p>{column.rowData.tipoSalario}</p>
    }


    const plantillaErrorSemanaJornadaReducida = (rowData, column) => {
        if (column.rowData.observacionJornadaReducida != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.semanaJornadaReducida + " " + column.rowData.observacionJornadaReducida}</p>

        else
            return <p >{column.rowData.semanaJornadaReducida}</p>
    }

    const plantillaErrorFechaMovimiento = (rowData, column) => {
        if (column.rowData.observacionFechaMovimiento != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.fechaMovimiento + " " + column.rowData.observacionFechaMovimiento}</p>
        else
            return <p >{column.rowData.fechaMovimiento}</p>
    }


    const plantillaErrorUmf = (rowData, column) => {
        if (column.rowData.observacionUmf != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.umf + " " + column.rowData.observacionUmf}</p>

        else
            return <p>{column.rowData.umf}</p>
    }

    const plantillaErrorNumeroGuia = (rowData, column) => {
        if (column.rowData.observacionNumeroGuia != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.numeroGuia + " " + column.rowData.observacionNumeroGuia}</p>

        else
            return <p>{column.rowData.numeroGuia}</p>
    }

    const plantillaErrorClaveTrabajador = (rowData, column) => {
        if (column.rowData.observacionClaveTrabajador != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.claveTrabajador + " " + column.rowData.observacionClaveTrabajador}</p>

        else
            return <p>{column.rowData.claveTrabajador}</p>
    }

    const plantillaErrorCurp = (rowData, column) => {
        if (column.rowData.observacionCurp != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.curp + " " + column.rowData.observacionCurp}</p>

        else
            return <p>{column.rowData.curp}</p>
    }

    const plantillaErrorCausaBaja = (rowData, column) => {
        if (column.rowData.observacionCausaBaja != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.causaBaja + " " + column.rowData.observacionCausaBaja}</p>

        else
            return <p>{column.rowData.causaBaja}</p>
    }

    const plantillaErrorTipoMovimiento = (rowData, column) => {
        if (column.rowData.observacionTipoMovimiento != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.tipoMovimiento + " " + column.rowData.observacionTipoMovimiento}</p>

        else
            return <p >{column.rowData.tipoMovimiento}</p>
    }

    const plantillaErrorLinea = (rowData, column) => {
        if (column.rowData.observacionLinea != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.observacionLinea}</p>
    }

    const plantillaErrorUltimoDigito = (rowData, column) => {
        if (column.rowData.observacionUltimiDigito != null)
            return <p style={{ color: '#FF334F' }}>{column.rowData.ultimoDigito + " " + column.rowData.observacionUltimiDigito}</p>

        else
            return <p >{column.rowData.ultimoDigito}</p>
    }

    return (
        <div>
            <DataTable value={datosTabla} responsive={true} header={titulo}
                paginator={true}
                rows={20}
                autoLayout={true}>
                <Column header="Linea" field="numeroLinea" />
                <Column header="Estatus" body={plantillaIconoValido} />
                <Column body={plantillaErrorRegistroPatronal} header="Registro Patronal" />
                <Column body={plantillaErrorNumeroSeguroSocial} header="Número seguro social" />
                <Column body={plantillaErrorDigitoVerificador} header="Dígito Verificador" />
                <Column body={plantillaErrorApellidoPaterno} header="Primer Apellido" />
                <Column body={plantillaErrorApellidoMaterno} header="Segundo Apellido" />
                <Column body={plantillaErrorNombre} header="Nombre" />
                <Column body={plantillaErrorSalarioBase} header="Salario Base" />
                <Column body={plantillaErrorTipoTrabajador} header="Tipo trabajador" />
                <Column body={plantillaErrorTipoSalario} header="Tipo Salario" />
                <Column body={plantillaErrorSemanaJornadaReducida} header="Jornada Reducida" />
                <Column body={plantillaErrorFechaMovimiento} header="Fecha Movimiento" />
                <Column body={plantillaErrorUmf} header="UMF" />
                <Column body={plantillaErrorNumeroGuia} header="Numero Guia" />
                <Column body={plantillaErrorClaveTrabajador} header="Clave Trabajador" />
                <Column body={plantillaErrorCurp} header="CURP" />
                <Column body={plantillaErrorCausaBaja} header="Causa Baja" />
                <Column body={plantillaErrorTipoMovimiento} header="Tipo Movimiento" />
                <Column body={plantillaErrorLinea} header="Formato" />
                <Column body={plantillaErrorUltimoDigito} header="Identificador del formato" />
            </DataTable>
        </div>
    );
}